import React, { useCallback, useEffect, useRef, useState } from 'react';
import { reformat } from '../../../../hooks/useMyStrings';
import NoteTooltip from '../meta/NoteTooltip';
import useWebSocketCaller from '../../../../hooks/useWebSocketCaller';
import { useItemListenerContext } from '../../../../providers/ItemListenerContextProvider';
import './KeyTitleEdit.css';

export default function KeyTitleEdit({folderPath, keyName, title, setLabelMode, kInfo, /*grabFocus,*/ tabIx}) {    
  const taggedEditingRef = useRef(false);
  const [content, setContent] = useState(kInfo.titleErrorInfo ? kInfo.titleErrorInfo.title : title);
  const {sendMessage} = useWebSocketCaller();
  const {tagTitleEditing, resetTitleKInfo} = useItemListenerContext();

  useEffect(()=>{
    if (!taggedEditingRef.current) {
      tagTitleEditing(folderPath, keyName)
        .then(()=>taggedEditingRef.current=true);
    }
  }, [tagTitleEditing, folderPath, keyName]);

  // Update Content
  const updateContent = useCallback((e) => {
    const update = reformat(e.target.value);
    setContent(update);
    // TODO: editValidateMe(update)
  },[]);

  const revert = useCallback(() => {
    if (taggedEditingRef.current) {
      taggedEditingRef.current = false;
      resetTitleKInfo(folderPath, keyName)
        .then(()=>setContent(title))
        .then(setLabelMode);
        // When collaborated edit/lock implemented, the reset should also call the server..
    }
  }, [resetTitleKInfo, folderPath, keyName, setContent, setLabelMode, title]);
  
  // ---[  SAVE  ]---
  //
  const save = useCallback(() => {
    if ((content !== title)) {
      sendMessage('update-config-title', {
        'basePath': folderPath,
        'key': keyName,
        'title': content
      });
    }      
    else {
      // console.log('[KeyTitleEdit] Revert');
      revert();
    }
  }, [folderPath, keyName, content, title, sendMessage, revert]);

  /** [Enter], [Esc] **/
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      save();
    }
    else if (e.key === 'Escape') {
      revert();
    }
    else if (e.key === 'F9') {      
      sendMessage('update-config-title',{
        'basePath': folderPath,
        'key': keyName,
        'title': ''
      });
    }
  }, [save, revert, sendMessage, folderPath, keyName]);

  const errSubject = kInfo.titleErrorInfo?.message      || '';
  const errBody    = kInfo.titleErrorInfo?.suggestion   || '';

  return (
    <div className='keyTitleEdit'>
      {errSubject && <NoteTooltip subject={errSubject} body={errBody} />}
      <input className='titleInput'
             type='text' value={content} 
             autoFocus={true}
             onChange={updateContent}
             onBlur={save}
             onKeyDown={handleKeyDown}
             tabIndex={tabIx}
            />
    </div>
  )
}
